var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"tooltip",rawName:"v-tooltip:[tooltipOptions]",value:(_vm.tooltipText),expression:"tooltipText",arg:_vm.tooltipOptions}],staticClass:"help-icon",class:_vm.iconClass})
}
var staticRenderFns = []

export { render, staticRenderFns }